<script lang="ts">
	import { _ } from "svelte-i18n";

	let { retry, reason }: { retry: () => void; reason: string } = $props();
</script>

<div class="wrapper">
	{$_("landingpage.newPresentation.generationDenied")}<br />
	<div class="error">{reason}</div>
	<button onclick={retry}>{$_("landingpage.newPresentation.retryWithDifferentPrompt")}</button>
</div>

<style>
	.wrapper {
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		gap: 0.5rem;
	}
	.error {
		color: red;
		font-weight: bold;
	}
</style>
